module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-c-1-fcc12337657b746c76fcede82fbd4c47.jpg";